// ================================================================
// Runner — اجرای scenario از طریق backend
// ================================================================

import { state } from './state.js';
import { apiRequest } from './apiClient.js';
import { getToken } from './auth.js';
import { t } from '../i18n/index.js';

export async function runScenario() {
  if (!getToken()) {
    throw new Error(t('oauth.notLoggedIn'));
  }

  const scenario = {
    nodes: state.nodes.map((n) => ({ id: n.id, type: n.type, config: n.config || {} })),
    connections: state.connections.map((c) => ({ fromId: c.fromId, toId: c.toId })),
  };

  return apiRequest('/api/run', {
    method: 'POST',
    body: JSON.stringify(scenario),
  });
}
